import { Typography } from 'antd';
import React from 'react';
import { pluralize } from 'components/ItemsInput/AddOrderItemOverlay/utils';
import ActionParameterForm from './ActionParameterForm';

const { Text } = Typography;

function WaitAction({ action, onFormsChange, disabled = false }) {
  const getWaitTitle = (code) => {
    if (code === 'wait_minutes') {
      const minutes = action.definition.find((item) => item.name === 'wait_minutes').initial;
      return `After ${minutes} ${pluralize('minute', minutes)}`;
    }
    if (code === 'wait_business_days') {
      const days = action.definition.find((item) => item.name === 'wait_days').initial;
      return `After ${days} business ${pluralize('day', days)}`;
    }
    return 'Wait Action';
  };

  return (
    <div>
      <Text strong className="block mb-2">
        {getWaitTitle(action.code)}
      </Text>

      {action.definition && action.definition.length > 0 && (
        <div className="bg-gray-50 rounded border border-gray-200 mt-2 hidden">
          <ActionParameterForm
            action={action}
            onFormsChange={onFormsChange}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}

export default WaitAction;
